import React from "react";

import {
  QuestionComponentProps,
  QuestionDefinition,
} from "@/components/survey/Question";
import { useAppContext } from "@/contexts";

import { ProgramResult } from "../dpp-triage/programResult/ProgramResult";

const QUESTION_ID = "retriageProgramResult";

declare module "@/contexts" {
  interface SurveyAnswers {
    wasOfferedDpp?: boolean;
    wasOfferedDiabetesSupport?: boolean;
  }
}

const RetriageProgramResult: React.FC<QuestionComponentProps> = ({
  onClickNext,
}) => {
  const { selectedProgram } = useAppContext();
  const wasOfferedDpp = selectedProgram === "DPP";
  const wasOfferedDiabetesSupport = selectedProgram === "DIABETES_LIFESTYLE";

  return (
    <ProgramResult
      onClickPrimaryCta={() =>
        onClickNext(null, { wasOfferedDpp, wasOfferedDiabetesSupport })
      }
    />
  );
};

export const Q_RETRIAGE_PROGRAM_RESULT: QuestionDefinition = {
  id: QUESTION_ID,
  shouldShowQuestion: ({ selectedProgram }) =>
    !!selectedProgram && !["MED", "MOOD", "NMPBA"].includes(selectedProgram),
  component: RetriageProgramResult,
};
